module.exports = __webpack_public_path__ + "static/media/moov money.e9c91b01.png";